import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { PaginatorModule } from "primeng/paginator";
import { TreeModule } from "primeng/tree";
import { DynamicFormsModule } from "../dynamic-forms/dynamic-forms.module";
import { ButtonModule } from "./button/button.module";
import { DetailHeaderTemplateModule } from "./detail-header-template/detail-header-template.module";
import { DetailMainTemplateComponent } from "./detail-main-template/detail-main-template.component";
import { DetailTemplateModule } from "./detail-template/detail-template.module";
import { GenericBorderTemplateModule } from "./generic-border-template/generic-border-template.module";
import { GridModule } from "./grid/grid.module";
import { IconModule } from "./icon/icon.module";
import { IframeComponent } from "./iframe/iframe.component";
import { InfoHeaderTemplateComponent } from "./info-header-template/info-header-template.component";
import { InfoTemplateModule } from "./info-template/info-template.module";
import { ListModule } from "./list/list.module";
import { LogoComponent } from "./logo/logo.component";
import { MenuModule } from "./menu/menu.module";
import { MessagingModule } from "./messaging/messaging.module";
import { PaginationComponent } from "./paginator/pagination/pagination.component";
import { PanelModule } from "./panel/panel.module";
import { PhoneNumberPipe } from "./pipes/phone.pipe";
import { SetTimeZoneTransformPipe } from "./pipes/SetTimeZoneTransformPipe";
import { PrivacyPolicyModule } from "./privacy-policy/privacy-policy.module";
import { StatisticsModule } from "./statistics/statistics.module";
import { TagModule } from "./tags/tag.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ButtonModule,
        GridModule,
        ReactiveFormsModule,
        MenuModule,
        DynamicFormsModule,
        DialogModule,
        PanelModule,
        IconModule,
        TreeModule,
        MessagingModule,
        DropdownModule,
        PaginatorModule,
        DragDropModule,
        PrivacyPolicyModule,
        DetailTemplateModule,
        DetailHeaderTemplateModule,
        InfoTemplateModule,
        ListModule,
        GenericBorderTemplateModule,
        StatisticsModule,
        TagModule,
    ],
    declarations: [
        LogoComponent,
        IframeComponent,
        PhoneNumberPipe,
        DetailMainTemplateComponent,
        PaginationComponent,
        SetTimeZoneTransformPipe,
        InfoHeaderTemplateComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ButtonModule,
        GridModule,
        IconModule,
        LogoComponent,
        ReactiveFormsModule,
        MenuModule,
        DynamicFormsModule,
        DialogModule,
        PanelModule,
        IframeComponent,
        MessagingModule,
        DropdownModule,
        PhoneNumberPipe,
        DetailMainTemplateComponent,
        PaginatorModule,
        PaginationComponent,
        SetTimeZoneTransformPipe,
        InfoHeaderTemplateComponent,
        DetailTemplateModule,
        DetailHeaderTemplateModule,
        InfoTemplateModule,
        ListModule,
        GenericBorderTemplateModule,
        StatisticsModule,
        TagModule,
    ],
})
export class SharedModule { }
